import { render, staticRenderFns } from "./manufacturerOverviewComponent.vue?vue&type=template&id=5029b08e&scoped=true"
import script from "./manufacturerOverviewComponent.vue?vue&type=script&lang=js"
export * from "./manufacturerOverviewComponent.vue?vue&type=script&lang=js"
import style0 from "./manufacturerOverviewComponent.vue?vue&type=style&index=0&id=5029b08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5029b08e",
  null
  
)

export default component.exports